module.exports = __webpack_public_path__ + "img/helixarts.5ce48348.png";